<!-- Breadcrumb -->
<ol class="breadcrumb">
  <li class="breadcrumb-item">
    <a routerLink="">Início</a>
  </li>
  <li class="breadcrumb-item">Minha Conta</li>
  <li class="breadcrumb-item active">
    Notas
  </li>
</ol>
<!-- //.Breadcrumb -->

<h4>Informe os dados para pesquisa</h4>
<div class="row">
  <div class="col-6">
    <form autocomplete="off" [formGroup]="filtroNotasFiscaisForm">
      <div class="row">
        <div class="form-group col-md">
          <label class="col-form-label" style="display:block;">Pesquisar por data:</label>
          <div class="form-check form-check-inline">
            <label class="form-check-label">
              <input class="form-check-input" name="criterio" formControlName="criterio"  type="radio" [value]="1" (change)="onChangeCriterio($event)">
              Data de Autorização
            </label>
          </div>
          <div class="form-check form-check-inline">
            <label class="form-check-label">
              <input class="form-check-input" name="criterio" formControlName="criterio" type="radio" [value]="2" (change)="onChangeCriterio($event)">
              Data de Emissão
            </label>
          </div>
        </div>
      </div>
      <div class="row" formGroupName="dateGroup">
        <div class="form-group col-md-6">
          <label for="dataInicial" class="col-form-label">Data Inicial</label>
          <div class="input-group">
              <input type="text" class="form-control" id="dataInicial" name="dataInicial" placeholder="dd/mm/aaaa" formControlName="dataInicial"
                [textMask]="maskData" (keyup)="onChangeDate($event)">
          </div>
          <div *ngIf="formErrors['dateGroup.dataInicial']" class="alert alert-danger">
            {{ formErrors['dateGroup.dataInicial'] }}
          </div>
        </div>
        <div class="form-group col-md-6">
          <label for="dataFinal" class="col-form-label">Data Final</label>
          <div class="input-group">
                <input type="text" class="form-control" id="dataFinal" name="dataFinal" placeholder="dd/mm/aaaa" formControlName="dataFinal"
                  [textMask]="maskData" (keyup)="onChangeDate($event)">
          </div>
          <div *ngIf="formErrors['dateGroup.dataFinal']" class="alert alert-danger">
             {{ formErrors['dateGroup.dataFinal'] }}
          </div>
        </div>

        <div *ngIf="formErrors.dateGroup" class="form-group col-md-12">
          <div class="alert alert-danger">
            {{ formErrors.dateGroup }}
          </div>
        </div>
      </div>
      <div class="form-group">
        <label for="municipio" class="col-form-label">Município:</label>
        <select id="municipio" class="form-control" formControlName="municipioId" (change)="onChangeMunicipio($event)">
            <option value="" selected>-- Selecione --</option>
            <option *ngFor="let municipio of municipios" [value]="municipio.codigoMunicipioIBGE">{{municipio.nome}}</option>
        </select>
      </div>

      <div class="row form-group col-md-12">
         <div>
          <button type="submit" [disabled]="!filtroNotasFiscaisForm.valid" (click)="onSubmit()" class="btn btn-bluelight mr-1"> Pesquisar </button>
         </div> 

        <div> 
          <li class="navbar-light" style="list-style-type: none;"  ngbDropdown [class.disabled]="!notasFiscais || notasFiscais.length === 0">
            <a class="btn btn-bluelight" role="button" data-toggle="dropdown" aria-haspopup="true"
              aria-expanded="false" id="DropdownDownloadRelatorio" ngbDropdownToggle>Exportar Relatório</a>
            <div class="dropdown-menu " ngbDropdownMenu aria-labelledby="DropdownDownloadRelatorio">
              <a class="dropdown-item" (click)="DownloadRelatorioNotasFiscais(tipoExportacao.PDF)">PDF</a>
              <a class="dropdown-item" (click)="DownloadRelatorioNotasFiscais(tipoExportacao.CSV)">CSV</a>
            </div>
          </li>
         </div>

  </div>
    </form>
    
    <br>
  </div>
  <div class="col-6">
    <div style="background-color:#d9e2ef;color:#000000;padding-bottom: 0px;padding-top: 11px;margin-bottom: 10px;" class="jumbotron card" _ngcontent-c6="">
      <div _ngcontent-c6="">
        <p class="text-justify">
          <strong _ngcontent-c6="">Atenção:</strong> A quantidade total de notas compartilhadas para as instituições é limitada a duas notas por estabelecimento comercial por dia no mesmo CPF.
        </p>
      </div>
    </div>
  </div>
</div>
<div *ngIf="MensagemErro" class="alert alert-danger col-sm-12">
  {{ MensagemErro }}
</div>
<div *ngIf="semRegistros" class="alert alert-danger col-sm-12">
  {{ notificacao }}
</div>
<div *ngIf="!validarForm" class="alert alert-danger col-sm-12">
  {{ campos }}
</div>
<div *ngIf="!validarFormPeriodoData" class="alert alert-danger col-sm-12">
  {{ periodoDataInvalida }}
</div>
<div class="row" *ngIf="notasFiscais">
  <div class="col" *ngIf="notasFiscais.length > 0">
      <table class="table table-striped" aria-describedby="Listagem Notas Fiscais cidadão">
          <thead>
              <tr>
                <th>Município</th>
                <th>Razão Social</th>
                <th>Data Emissão</th>
                <th>Número</th>
                <th>Data de Autorização</th>
                <th>Valor</th>
                <th>Gera Bilhete?</th>
              </tr>
            </thead>
            <tbody>
                <tr *ngFor="let notaFiscal of notasFiscais; let i = index">
                  <td>
                      {{ notaFiscal.des_municipio }}
                  </td>
                  <td>{{ notaFiscal.nom_razao_social }}</td>
                  <td>{{ notaFiscal.dtc_emissao | date:'dd/MM/yyyy' }}</td>
                  <td><a class="sublinhe" (click)="encaminharParaNota(notaFiscal, i)">{{ notaFiscal.num_nota_fiscal }}</a></td>
                  <td>{{ notaFiscal.dtc_recepcao_origem | date:'dd/MM/yyyy HH:mm:ss' }}</td>
                  <td>{{ notaFiscal.val_total | currency:'BRL':'symbol':'1.2-2' }}</td>
                  <td>{{ notaFiscal.nota_Participante }}</td>
                </tr>
              </tbody>
      </table>
  </div>
  <div class="col-12 text-right" *ngIf="notasFiscais.length > 0">
    <ngb-pagination [collectionSize]="notasFiscaisService.totalNotasParticipantes" [(page)]="pagina" [maxSize]="10" [rotate]="true" [ellipses]="false" [boundaryLinks]="true"
      (pageChange)="pageChange($event)">
    </ngb-pagination>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/restrito/consumidor/consumidor-notas/consumidor-notas.component.html